.container {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.itemBox {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 1rem;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.itemGrid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem 1rem;
}

.gridItem {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.label {
  font-size: 0.875rem;
  color: #666;
  font-weight: 500;
}

.value {
  font-size: 1rem;
  color: #333;
  font-weight: 400;
}

.additionalQty {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding-top: 0.5rem;
  border-top: 1px solid #eee;
}

.transactionControls {
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  padding-top: 0.5rem;
  border-top: 1px solid #eee;
  align-items: flex-end;
  flex-wrap: wrap;
}

.inputGroup {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 0 0 auto;
}

.transactInput {
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  width: 200px;
}

.transactInput:focus {
  outline: none;
  border-color: #0066cc;
  box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.1);
}

.buttonGroup {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.actionButton {
  flex: 0 1 auto;
  min-width: 120px;
}

/* Scrollbar styling */
.container::-webkit-scrollbar {
  width: 8px;
}

.container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.container::-webkit-scrollbar-thumb:hover {
  background: #555;
}
